export default {"src":"/_next/static/media/sellWithUs.25c964b2.svg","height":48,"width":48};